export const scrollStore = { hero: 0, exp: 0 };
